import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './NotificationSettings.scss';

const NotificationSettings: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="notification-settings">
      <div className="notification-settings__title">{t('settings.general.notifications')}</div>
      <div className="notification-settings__title__light">
        {t('settings.general.notificationsWebUnsupported')}
      </div>
    </div>
  );
};

export default NotificationSettings;
